export var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["Init"] = 0] = "Init";
    GameStatus[GameStatus["Gaming"] = 1] = "Gaming";
    GameStatus[GameStatus["GameOver"] = 2] = "GameOver";
    GameStatus[GameStatus["Win"] = 3] = "Win";
})(GameStatus || (GameStatus = {}));
